import { Link } from "react-router-dom";
import HeroSection from "@/pages/home/components/HeroSection";
import LiveSpotlight from "@/pages/home/components/LiveSpotlight";
import ScheduleTimeline from "@/pages/home/components/ScheduleTimeline";
import LeagueEntries from "@/pages/home/components/LeagueEntries";
import LatestNews from "@/pages/home/components/LatestNews";

export default function Home() {
  return (
    <div className="w-full">
      <HeroSection />
      <LiveSpotlight />
      <ScheduleTimeline />
      <LeagueEntries />
      <LatestNews />

      <section className="w-full px-4 md:px-6 pb-16">
        <div className="rounded-lg bg-primary-950 px-6 py-10 md:px-12 md:py-14 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div className="max-w-2xl text-center lg:text-left">
            <h2 className="font-heading font-semibold text-2xl md:text-3xl text-background-50">
              关于篮球直播
            </h2>
            <p className="mt-3 text-primary-200 text-sm md:text-base leading-relaxed">
              我们致力于为篮球爱好者打造一站式观赛平台：高清比赛实况、详尽赛程安排、专业赛事资讯与数据回顾。
              无论你是资深球迷还是刚入门的观众，都能在这里找到属于自己的篮球时刻。
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 hover:bg-accent-600 text-background-50 dark:text-foreground-950 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              了解我们
              <i className="ri-arrow-right-s-line" />
            </Link>
            <Link
              to="/news"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-50/30 text-background-50 hover:bg-background-50/10 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览资讯
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}